import { StudioImage } from "@/components/ui-nw/StudioImage";

const SECTIONS = [
  { n: 1, image: "wave-create", alt: "AI music artist in a red-lit urban setting", title: "Create without limits",
    text: "Your imagination is the blueprint. Make the music, build the visuals, and bring your artistic vision to life." },
  { n: 2, image: "wave-express", alt: "Artist performing on stage under red lights", title: "Express yourself",
    text: "Your sound. Your style. Your story. NEW WAVE is where your creativity comes alive." },
  { n: 3, image: "wave-heard", alt: "Artist performing for an energetic crowd", title: "Get heard. Get seen.",
    text: "Share your work. Connect with fans. Discover new creators. Build your audience." },
];

export const StudioMosaic = () => (
  <section data-testid="landing-wave-sections" className="divide-y divide-white/10">
    {SECTIONS.map(({ n, image, alt, title, text }) => (
      <article key={n} data-testid={`landing-wave-section-${n}`} className="grid grid-cols-[42%_1fr] sm:grid-cols-[280px_1fr] items-center gap-4 sm:gap-10 py-6 sm:py-8 first:pt-0 last:pb-0">
        <figure className="relative aspect-[3/4] overflow-hidden rounded-2xl border border-white/10 bg-nw-surface">
          <StudioImage name={image} alt={alt} sizes="(min-width: 640px) 280px, 42vw" className="absolute inset-0 h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
        </figure>
        <div className="space-y-2 sm:space-y-3">
          <p className="font-mono text-[11px] tracking-[0.3em] text-nw-red">0{n}</p>
          <h2 className="font-display text-lg sm:text-3xl font-extrabold uppercase tracking-tight chrome-text">{title}</h2>
          <p className="text-sm sm:text-base leading-relaxed text-slate-300 max-w-md">{text}</p>
        </div>
      </article>
    ))}
  </section>
);
